import { combineEpics } from 'redux-observable';
import makeDefaultGroupEpic from './make-default-group';
import sendActivationEmailEpic from './send-activation-email';

export default combineEpics(makeDefaultGroupEpic, sendActivationEmailEpic);
